import {
  Overlay,
  OverlayRef,
  ScrollStrategyOptions,
} from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import {
  Directive,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';
import { IMedia } from '@epicuro-next/ataraxia/models';
import { merge } from 'rxjs';
import { take } from 'rxjs/operators';

import { MediaLightboxComponent } from '../../components/media-lightbox/media-lightbox.component';

@Directive({
  selector: '[atxMediaLightbox]',
  standalone: false,
})
export class MediaLightboxDirective {
  @Input()
  public atxMediaLightbox: IMedia[];

  @Input()
  public atxMediaAsideContent: TemplateRef<HTMLElement>;

  @Input()
  public atxMediaLightboxSelectedIndex = 0;

  @HostBinding('style.cursor')
  public cursor = 'pointer';

  @Output()
  public atxMediaLightboxOpened = new EventEmitter<void>();

  @Output()
  public atxMediaLightboxClosed = new EventEmitter<void>();

  private overlayRef: OverlayRef;

  @HostListener('click', ['$event'])
  public openLightbox(event: Event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    this.overlayRef = this.overlay.create({
      height: '100vh',
      hasBackdrop: true,
      scrollStrategy: this.scrollStrategyOptions.block(),
      disposeOnNavigation: true,
      panelClass: 'relative',
      backdropClass: 'media-lighbox-backdrop',
    });

    const lightboxRef = this.overlayRef.attach(
      new ComponentPortal(MediaLightboxComponent),
    );

    lightboxRef.instance.mediaList = this.atxMediaLightbox;
    lightboxRef.instance.selectedIndex = this.atxMediaLightboxSelectedIndex;
    lightboxRef.instance.asideContent = this.atxMediaAsideContent;

    this.atxMediaLightboxOpened.emit();
    merge(
      this.overlayRef.backdropClick(),
      lightboxRef.instance.closeButtonPress,
    )
      .pipe(take(1))
      .subscribe(() => {
        this.overlayRef.dispose();
        this.atxMediaLightboxClosed.emit();
      });
  }

  constructor(
    private overlay: Overlay,
    private scrollStrategyOptions: ScrollStrategyOptions,
  ) {}
}
